import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';

class SyllabusDashboard extends Component {
	state = {};
	componentDidMount() {
		$(document).click(function(e) {
			if (!$(e.target).is('.panel-body')) {
				$('.collapse').collapse('hide');
			}
		});
	}
	render() {
		return (
			<div>
				<section class="mb-4">
					<h3 class="h3-responsive font-weight-bold text-center my-4">
						Syllabus Dashboard
					</h3>
					<div
						class="row"
						style={{
							justifyContent: 'center',
							textAlign: 'center',
							marginBottom: -45
						}}
					>
						<div class="col-md-8">
							<div class="md-form mb-0">
								<hr class="style-head" />
							</div>
						</div>
					</div>

					<p class="text-center w-responsive mx-auto mb-5" />

					<div
						class="row"
						style={{ textAlign: 'center', justifyContent: 'center' }}
					>
						<div class="col-md-9 mb-md-0 mb-5">
							<form id="contact-form" name="contact-form">
								<div class="row">
									<div class="col-md-6">
										<div class="md-form mb-0">
											<Link to="/dashboard/AddSyllabus">
												<img
													src={require('../Assets/SyllabusDashboard/add syllabus.svg')}
													width="200"
													height="200"
												/>
											</Link>
										</div>
									</div>
									<div class="col-md-6">
										<div class="md-form mb-0">
											<Link to="/dashboard/ViewSyllabus">
												<img
													src={require('../Assets/SyllabusDashboard/view syllabus.svg')}
													width="200"
													height="200"
												/>
											</Link>
										</div>
									</div>
									<div class="col-md-12 text-center">
										<div class="md-form mb-0">
											<Link to="/dashboard/ViewAllSyllabus">
												<img
													src={require('../Assets/SyllabusDashboard/view syllabus template.svg')}
													width="200"
													height="200"
												/>
											</Link>
										</div>
									</div>
								</div>
							</form>
							<div class="status" />
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default SyllabusDashboard;
